import { fg } from '@atlaskit/platform-feature-flags';
import type { FilterId } from '@atlassian/rovo-connectors-config/types/filters';

import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI } from '../../default-cloud-graph-devinfo-branch-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI } from '../../default-cloud-graph-devinfo-commit-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI } from '../../default-cloud-graph-project-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../default-cloud-graph-work-item-entity-ati';
import { TypeFilterValueKey } from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ForgePioGithubIcon } from './icon';
import { ForgePioGithubSearchResultIcon } from './search-result-icon';

export const forgePioGithubConfig: ThirdPartyConfig = {
	displayName: 'Github by Pio',
	id: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
	resourceType: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
	icon: get3PLogo(ForgePioGithubIcon, 'ForgePioGithub', 'medium'),
	searchResultIcon: get3PLogo(ForgePioGithubSearchResultIcon, 'ForgePioGithub', 'large'),
	integrationAri: 'ari:cloud:platform::integration/0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Comment,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Commit,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Branch,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Project,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	get filters(): FilterId[] {
		const baseFilters: FilterId[] = ['lastUpdated', 'pullRequestStatus'];
		if (fg('rovo_fps_show_repository_filter')) {
			baseFilters.push('repository');
		}
		if (fg('rovo_fps_show_github_created_by_filter')) {
			baseFilters.push('createdBy');
		}
		return baseFilters;
	},
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
